import React, { useState } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from '../../firebase-service/auth'
import { useAuth } from '../../context/authContext'
import { toast } from 'sonner'
import LogoFantasy from '../../assets/img/logo-fantasy.png'
import "./LoginFantasy.scss"

function getLoginErrorMessage(error) {
    switch (error?.code) {
        case 'auth/popup-closed-by-user':
        case 'auth/cancelled-popup-request':
            return 'Has cerrado el inicio de sesión'
        case 'auth/network-request-failed':
            return 'Sin conexión. Inténtalo de nuevo'
        case 'auth/user-disabled':
            return 'Esta cuenta está deshabilitada'
        case 'auth/invalid-credential':
        case 'auth/wrong-password':
        case 'auth/user-not-found':
            return 'Email o contraseña incorrectos'
        default:
            return 'No se pudo iniciar sesión'
    }
}

export function LoginFantasy () {
    const { userLoggedIn } = useAuth()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isSigningIn, setIsSigningIn] = useState(false)

    const onSubmit = async (e) => {
        e.preventDefault()
        if(!isSigningIn) {
            setIsSigningIn(true)
            try {
                await doSignInWithEmailAndPassword(email, password)
            } catch (err) {
                setIsSigningIn(false)
                toast.error(getLoginErrorMessage(err))
            }
        }
    }

    const onGoogleSignIn = async (e) => {
        e.preventDefault()
        if (!isSigningIn) {
            setIsSigningIn(true)
            try {
                await doSignInWithGoogle()
            } catch (err) {
                setIsSigningIn(false)
                toast.error(getLoginErrorMessage(err))
            }
        }
    }

    return (
        <main className="login-main-container">
            {userLoggedIn && (<Navigate to={'/fantasy/home'} replace={true} />)}
            <div className="login-container">
                <div className='login-fantasy-logo'>
                    <img src={LogoFantasy} alt="Logo" className="logo-fantasy" />
                </div>
                <div className='login-button-container'>
                    <button disabled={isSigningIn} onClick={(e) => { onGoogleSignIn(e) }} className="login-button">
                        {isSigningIn ? 'Iniciando Sesión...' : 'Continuar con Google'}
                    </button>
                </div>
            </div>
        </main>
    )
}